import { render, staticRenderFns } from "./BackofficeTipoLesao.vue?vue&type=template&id=100eb7c3&scoped=true"
import script from "./BackofficeTipoLesao.vue?vue&type=script&lang=ts"
export * from "./BackofficeTipoLesao.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeTipoLesao.vue?vue&type=style&index=0&id=100eb7c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100eb7c3",
  null
  
)

export default component.exports